// TODO: this should become a Context once we move to a SPA
import { useSelector } from 'react-redux';
import { IStore } from 'src/explore/types/store';

export const useSettings = () => useSelector(( state: IStore ) => state.data.settings );
